import { Translation } from '@jsverse/transloco';

const rw: Translation = {
  citizen: {
    loginToContinue: 'Injira kugirango ukomeze',
  },
  location: {
    province: 'Intara',
    district: 'Akarere',
    sector: 'Umurenge',
    cell: 'Akagari',
    village: 'Umudugudu',
  },
  form: {
    title: {
      addCategory: 'Ongeraho icyiciro',
      editCategory: 'Hindura icyiciro',
      addAccount: 'Umukozi mushya',
      editAccount: 'Hindura umukozi',
      addInstitution: 'Ikigo gishya',
      editInstitution: 'Hindura ikigo',
      editRole: 'Hindura inshingano',
      newCase: 'Ikibazo gishya',
      editCase: 'Hindura ikibazo',
      newAnnouncement: 'Itangazo rishya',
      editAnnouncement: 'Hindura itangazo',
      newCitizen: 'Umuturage mushya',
      editCitizen: 'Hindura umuturage',
      anonymousComplaint: "Ikibazo cy'ibanga",
      orientationLevel: 'Aho ibibazo bikurikiranwa',
      location: 'Aho Akorera (Ni amahitamo)',
      locationDescription:
        'Niba nta hantu hashyizweho, umukozi azajya akurikirana ibibazo mu duce twose',
      amountDescription: 'byatoranijwe',
      escalateCase: "Zamura urwego rw'ikibazo",
    },
    label: {
      kinyarwanda: 'Ikinyarwanda',
      english: 'Icyongereza',
      french: 'Igifaransa',
      firstName: 'Izina rya mbere',
      middleName: 'Izina ryo hagati',
      lastName: 'Izina rya nyuma',
      documentType: 'Icyangombwa',
      documentNumber: "Nimero y'Icyangombwa",
      name: 'Amazina',
      phoneNumber: 'Telefoni',
      gender: 'Igitsina',
      email: 'Imeri',
      nationalId: 'Indangamuntu',
      province: 'Intara',
      district: 'Akarere',
      sector: 'Umurenge',
      cell: 'Akagari',
      village: 'Umudugudu',
      title: 'Ikibazo',
      password: "Ijambo ry'ibanga",
      description: 'Ubusobanuro',
      caseType: "Icyiciro cy'ikibazo",
      severity: 'Uburemere',
      victimsNumber: 'Abagize ikibazo',
      trackingLevel: 'Urwego',
      estimateDays: 'Igihe byatwara',
      primaryOrganization: 'Ikigo gikurikirana ikibazo',
      informedOrganization: 'Ibigo bimenyeshejwe ikibazo',
      issueLocation: 'Aho Ikibazo cyabereye',
      issueDetails: "Ubusobanuro bw'ikibazo",
      orientationLevel: 'Aho ibibazo bikurikiranwa',
      recordingLevel: 'Urwego',
      complaint: 'Ikibazo',
      goodGovernanceSection: "Ishami ry'imiyoborere myiza",
      search: 'Shakisha',
      role: 'Inshingano',
      occupation: 'Umwanya',
      institution: 'Ikigo',
      from: 'Kuva',
      to: 'Kugera',
      roleValidity: 'Igihe inshingano zizamara',
      roleValidityDescription:
        'Ni igihe inshingano zizamara, igihe kitashyizweho zigomba kuzamara burundu',
      assignPermission: 'Tanga uburenganzira',
      locationSearch: 'Hitamo',
      organization: 'Ikigo',
      citizen: 'Umuturage',
      reason: 'Impamvu yo kwanga ikibazo',
      reasonForEscalation: "Impamvu yo kuzamura urwego rw'ikibazo",
      reasonMustBeAtLeast50Characters:
        "Impamvu yo kuzamura urwego rw'ikibazo nitgomba kuba hasi y'inyuguti 50",
      minimumCharacters: 'inyuguti zisabwa',
      characters: 'inyuguti',
    },
    placeholder: {
      documentType: "Andika ubwoko bw'inyandiko",
      documentNumber: "Andika nomero y'inyandiko",
      name: 'Andika amazina',
      phoneNumber: 'Shyiramo nimero ya Telefoni',
      gender: 'Hitamo',
      email: 'Shyiramo Imeri',
      nationalId: 'Shyiramo Indangamuntu',
      province: 'Hitamo Intara',
      district: 'Hitamo Akarere',
      sector: 'Hitamo Umurenge',
      cell: 'Hitamo Akagari',
      village: 'Hitamo Umudugudu',
      title: 'Andika Ikibazo',
      password: "Shyiramo Ijambo ry'Ibanga",
      complaint: 'Shyiramo ikibazo cyose',
      description: 'Shyiramo Ubusobanuro',
      caseType: "Hitamo ubwoko bw'ikibazo",
      severity: "Hitamo uburemere bw'ikibazo",
      victimsNumber: 'Hitamo umubare wabagize ikibazo',
      trackingLevel: 'Hitamo urwego rwo gukurikirana',
      estimateDays: 'Injiza iminsi iteganijwe',
      primaryOrganization: 'Hitamo ikigo nyamukuru',
      informedOrganization: 'Hitamo ibigo byamenyeshejwe',
      issueLocation: "Injiza amakuru y'aho Ikibazo Cyabereye",
      issueDetails: "Injiza ibisobanuro by'ikibazo",
      orientationLevel: 'Hitamo urwego rwo gukurikirana dosiye',
      recordingLevel: 'Hitamo urwego rwo kwandika',
      searchInstitution: 'Shakira aha',
      firstName: 'Andika izina rya mbere',
      lastName: 'Andika izina rya nyuma',
      occupation: 'Shyiramo Umwanya',
      institution: 'Ibigo byose',
      search: 'Shakira aha',
      locationSearch: 'Hitamo ahantu',
      organization: 'Hitamo Ikigo',
      role: 'Hitamo Inshingano',
      explainWhyYouAreEscalatingThisCase:
        "Shyiramo impamvu yo kuzamura urwego rw'ikibazo (byibuze inyuguti 50)",
    },
    button: {
      forgotPassword: "Wibagiwe Ijambo ry'Ibanga?",
      login: 'Injira',
      resetPassword: "Hindura Ijambo ry'Ibanga",
      alreadyHaveAnAccount: 'Usanzwe ufite konti?',
      submitButton: 'Ohereza',
      signUp: 'Iyandikishe',
      ok: 'Yego',
      cancel: 'Hagarika',
      addCategory: 'Ongeraho icyiciro',
      editCategory: 'Hindura icyiciro',
      addAccount: 'Ongeraho konti',
      editAccount: 'Hindura konti',
      editInstitution: 'Hindura ikigo',
      newCase: 'Ikibazo gishya',
      editCase: 'Hindura ikibazo',
      newAnnouncement: 'Itangazo rishya',
      editAnnouncement: 'Hindura Itangazo',
      newCitizen: 'Umuturage mushya',
      editCitizen: 'Hindura Umuturage',
      casesStatus: {
        closed: 'Cyanzuwe',
        ongoing: 'Kirigukorwaho',
        done: 'Cyakemutse',
        resolved: 'Cyakemutse',
        re_opened: 'Cyajuriwe',
        reOpened: 'Cyajuriwe',
      },
    },

    options: {
      severity: {
        low: 'Budakabije',
        medium: 'Bugereranije',
        high: 'Bukomeye',
        critical: 'Bukomeye Cyane',
      },
      trackingLevel: {
        national: 'Igihugu',
        province: 'Intara',
        district: 'Akarere',
        sector: 'Umurenge',
        cell: 'Akagari',
        village: 'Umudugudu',
      },
      victimsNumber: {
        one: 'Umwe',
        multiple: 'Benshi',
      },
    },
    errors: {
      emailPhoneRequired: 'Imeri cyangwa nimero ya telefoni irakenewe',
      passwordRequired: "Ijambo ry'ibanga rigomba kuba nibura inyuguti 8",
      codeRequired: 'Kode yemeza irakenewe',
    },
  },
  resetPasswordForm: {
    title: "Hindura Ijambo ryawe ry'ibanga",
    description:
      "Shyiramo Ijambo ry'Ibanga rishya kugirango ukomeze ubone urubuga",
    label: {
      code: "Ijambo ry'ibanga rya kera",
      newPassword: "Ijambo ry'ibanga rishya",
    },
    placeholder: {
      code: "Andika Ijambo ry'ibanga rya kera",
      enterNewPassword: "Andika Ijambo ry'Ibanga rishya",
    },
    button: "Saba guhindura Ijambo ry'Ibanga",
  },
  casesStatus: {
    closed: 'Cyanzuwe',
    ongoing: 'Kirigukurikiranwa',
    resolved: 'Cyakemutse Burundu',
    done: 'Cyakemutse Burundu',
    reopened: 'Cyagaruwe',
    pending: 'Cyirategereje',
  },
  announcementStatus: {
    published: 'Ryatangarijwe',
    unpublished: 'Ryarangiye',
  },
  noCasesFound: 'Nta bibazo byabonetse',
  fetchingData: 'Gushaka amakuru...',
  editPersonalInfo: 'Amakuru Yawe',
  editPersonalInfoDescription:
    'Aya makuru akurwa ku ndangamuntu, ntiyahindurwa',
  changePassword: "Hindura Ijambo ry'Ibanga",
  changePasswordDescription:
    "Shyiramo ijambo ry'ibanga ukoreshaka kugira ngo urihindue",
  currentPassword: "Ijambo ry'Ibanga rya Kera",
  confirmPassword: "Emeza Ijambo ry'Ibanga",
  enterConfirmPassword: "Emeza Ijambo ry'Ibanga",
  enterCurrentPassword: "Shyiramo Ijambo ry'Ibanga rya Kera",
  // MENU
  dashboard: 'Ibikubiyemo',
  complaints: 'Ibibazo byakiriwe',
  announcements: 'Amatangazo',
  tipOffs: "Amakuru y'Ibanga",
  notificationSettings: "Amagenamiterere y'amatangazo",
  notificationSettingsDescription:
    'Gucunga uburyo ushaka kwakiramo amatangazo ya sisitemu.',
  addReportingNotification: 'Ongeraho imenyesha rya raporo',
  createNotification: 'Kora imenyesha',
  reportingNotificationHelperText:
    "Kora imenyesha rya raporo ushingiye ku rwego rwo gukurikirana, ahantu hagenwe n'imeri yoherezwaho.",
  notificationChannelDescription:
    'Fungura cyangwa uzimye ubu buryo bwo kwakira amatangazo kuri konti yawe.',
  selectRecordingLevel: 'Hitamo urwego rwo gukurikirana',
  selectOrganization: 'Hitamo ikigo',
  assignedLocations: 'Ahantu hagenwe',
  searchAssignedLocations: 'Shakisha ahantu hagenwe',
  enterNotificationEmail: "Andika imeyili y'imenyesha",
  assignedLocationRequired: 'Nibura ahantu hamwe harasabwa',
  manage: 'Gucunga',
  citizens: 'Abaturage',
  institutions: 'Ibigo',
  accounts: 'Konti',
  security: 'Umutekano',
  overview: 'Incamake',
  cases: 'Ibibazo',
  analytics: 'Isesengura',
  staff: 'Abakozi',
  rolesAndPermissions: "Inshingano n'Uburenganzira",
  systemSettings: 'Igenamiterere rya Sisiteme',
  auditLog: 'Ibyakozwe  muri Sisiteme',
  tipOffCategories: "Ibyiciro by'Amakuru y'Ibanga",

  tipOffCategoryPage: {
    title: "Ibyiciro by'Amakuru y'Ibanga",
    description: "Gucunga ibyiciro by'Amakuru y'Ibanga",
    action: {
      addNewCategory: 'Ongeraho icyiciro',
    },
  },
  modal: {
    title: 'Gushungura',
    byInstitution: 'Hakurikijwe ikigo',
    clear: 'Gusiba Ibyakozwe',
    apply: 'Emeza',
    edit: 'Hindura',
    view: 'Reba',
    deactivate: 'Hagarika',
    activate: 'Fungura',
    delete: 'Siba',
  },
  home: 'Ahabanza',
  landingPageTitle: 'Ikaze kuri Mbaza',
  noDocumentsFound: 'Nta mpapuro zabonetse',
  myDashboard: 'Urubuga rwanjye',
  reportAnonymously: "Tanga Ikibazo mw'Ibanga",
  quickOverview: 'Amakuru Yandi',
  welcome: 'Murakaza neza',
  tipOffCategory: 'Icyiciro',
  tipOffCategoryPlaceholder: 'Hitamo icyiciro',
  newAnonymousComplaint: "Tanga Ikibazo mw'Ibanga",
  issueDescription: "Ubusobanuro Bw'Ikibazo",
  enterIssueDescription: "Andika ubusobanuro bw'Ikibazo",
  issueTitlePlaceholder: 'Andika Ikibazo',
  submitComplaint: 'Tanga ikibazo',
  submitComplaintButton: 'Tanga ikibazo',
  newComplaint: 'Ikibazo gishya',
  // cases: "Ibibazo",
  closed: 'Ibyanzuwe',
  ongoing: 'Ibigikorwaho',
  nationalId: 'Indangamuntu',
  name: 'Amazina',
  phoneNumber: 'Nimero ya telefoni',
  gender: 'Igitsina',
  email: 'Imeri',
  complaintsAndCases: 'Ibibazo',
  searchHere: 'Shakisha hano',
  underReview: 'Ibibazo bitarakorwaho',
  myComplaints: 'Ibibazo byanjye',
  statusOngoing: 'Ibigikorwaho',
  statusPending: 'Ibitarakorwaho',
  statusReOpened: 'Ibyajuriwe',
  statusClosed: 'Ibyanzuwe',
  statusDone: 'Ibyakemutse',
  issueLocation: 'Aho Ikibazo Cyabereye',
  district: 'Akarere',
  sector: 'Umurenge',
  cell: 'Akagari',
  village: 'Umudugudu',
  selectDistrict: 'Hitamo akarere',
  selectSector: 'Hitamo umurenge',
  selectCell: 'Hitamo akagari',
  selectVillage: 'Hitamo umudugudu',
  issueDetails: "Ubusobanuro bw'ikibazo",
  title: 'Ikibazo',
  enterTitle: 'Andika Ikibazo',
  complaint: 'Ikibazo',
  complaintTitle: 'Ikibazo',
  typeYourComplaint: 'Andika Ikibazo Cyawe mu buryo burambuye',
  download: 'Pakurura',
  noFilesAttached: 'Nta madosiye yometse',
  complaintDetails: "Ubusobanuro bw'ikibazo",
  reportedOn: 'Byatanzwe ku wa',
  close: 'Funga',
  loading: 'Biratangurirwa...',
  supportingAttachments: "Inyandiko n'Ibimenyetso",
  caseDetails: "Ubusobanuro bw'ikibazo",
  reportedBy: 'Byatanzwe na',
  informedInstitutions: 'Ibigo byamenyeshejwe',
  noOrganizationsInformed: 'Nta bigo byamenyeshejwe',
  caseTimeline: "Igihe cy'ikibazo",
  tracking: 'Kurikirana',
  trackingPlaceholder: "Andika code y'ikibazo",
  trackingLevel: "Urwego rw'ikurikirana",
  createdBy: 'Byakozwe na',
  assignedTo: 'Byahawe',
  primaryOrganization: "Ikigo cy'ibanze",
  none: 'Nta na kimwe',
  myProfile: 'Umwirondoro wanjye',
  profile: 'Umwirondoro',
  logout: 'Sohoka',
  login: 'Injira',
  register: 'Kwiyandikisha',
  trackComplaint: 'Kurikirana ikibazo',
  trackAnotherComplaint: 'Kurikirana ikindi kibazo',
  reportedAComplaint: 'Yatanze ikibazo',
  createdACase: 'Yakoze ikibazo',
  addedAComment: 'Yongeyeho igitekerezo',
  tagged: 'Yavuze',
  you: 'wowe',
  trackYourComplaint: 'Kurikirana ikibazo cyawe',
  mostCasePerDistrict: 'Uturere dufite ibibazo byinshi',
  mostCasePerInstitution: 'Ibigo bifite ibibazo byinshi',
  mostCasePerCategory: 'Ibyiciro bifite ibibazo byinshi',
  mostCasePerChannel: 'Uburyo bwakoreshejwe',
  caseTrendThisYear: 'Uko ibibazo byahindutse muri uyu mwaka',
  notifications: 'Amakuru mashya',
  newCase: 'Ikibazo gishya',
  createCase: 'Kora ikibazo',
  nonOrientedComplaints: 'Ibibazo bitayoborwa',
  filterComplaints: 'Shuza ibibazo',
  today: 'Uyu munsi',
  thisWeek: 'Iki cyumweru',
  thisMonth: 'Uku kwezi',
  thisYear: 'Uyu mwaka',
  allTime: 'Igihe cyose',
  enterNamesKeyword: 'Andika amazina, Ijambo...',
  retry: 'Ongera ugerageze',
  urgentCases: 'Ibyihutirwa',
  urgent: 'Ibyihutirwa',
  notUrgent: 'Ibitihutirwa',
  nothingToShow: 'Nta kintu cyo kwerekana',
  thisListIsEmpty: 'Urutonde rusa',
  filter: 'Shuza',
  allCases: 'Ibibazo',
  selectStatus: 'Hitamo imimerere',
  selectCategory: 'Hitamo icyiciro',
  selectOwnership: 'Hitamo uwubifitemo',
  primaryCases: "Ibibazo by'ibanze",
  secondaryCases: 'Ibibazo bya kabiri',
  status: 'Imimerere',
  type: 'Ubwoko',
  filterCases: 'Shuza ibibazo',
  byProvince: 'Hakurikijwe Intara',
  byLocation: 'Hakurikijwe ahantu',
  byStatus: 'Hakurikijwe imimerere',
  byPeriod: 'Hakurikijwe igihe',
  byInstitutions: 'Hakurikijwe ibigo',
  bySeverityAndUrgency: 'Hakurikijwe Uburemere',
  institution: 'Ikigo',
  severity: 'Uburemere',
  urgency: 'Ubwihuse',
  ownership: ' Uwubifitemo',
  allStatus: 'Imimerere yose',
  allTypes: 'Ubwoko bwose',
  allOwnerships: 'Abafite byose',
  allProvinces: 'Intara zose',
  allDistricts: 'Uturere twose',
  allSectors: 'Imirenge yose',
  allCells: 'Utugari twose',
  allVillages: 'Imidugudu yose',
  allInstitutions: 'Ibigo byose',
  allSeverities: 'Ubukomeye bwose',
  allUrgencies: 'Ubwihuse bwose',
  clearFilters: 'Kuraho ishuza',
  filterList: "Urutonde rw'ishuza",
  dateRange: 'Igihe',
  period: 'Igihe',
  selectHere: 'Hitamo hano',
  mostCasesPerCategory: 'Ibyiciro bifite ibibazo byinshi',
  mostCasesPerInstitutions: 'Ibigo bifite ibibazo byinshi',
  mostCasesPerDistrict: 'Uturere dufite ibibazo byinshi',
  noDataAvailable: 'Nta makuru aboneka',
  totalCases: 'Ibibazo byose',
  new: 'Gishya',
  reopened: 'Ibyajuriwe',
  avgReactionTime: 'Igihe cyo gusubiza',
  reactionTimeDay: 'umunsi',
  reactionTimeDays: 'iminsi',
  reactionTimeHour: 'isaha',
  reactionTimeHours: 'amasaha',
  reactionTimeAnd: 'na',
  avgSatisfaction: 'Ibyishimye',
  done: 'Ibyakemutse',
  casesTrendPerYear: 'Uko ibibazo byahindutse mu mwaka',
  casesOnTheMap: 'Ibibazo ku karita',
  totalCitizens: 'Abaturage bose',
  withOngoingCases: 'Bafite ibibazo bikiri Gukorwaho',
  avgCasesPerUser: 'Ibibazo ku mukoresha',
  avgCasesPerInstitution: 'Ibibazo ku mukoresha ku ikigo',
  female: 'Gore',
  male: 'Gabo',
  foreigners: 'Abanyamahanga',
  newCitizen: 'Umuturage mushya',
  createCitizen: 'Kora umuturage',
  saveChanges: 'Emeza',
  editCitizen: 'Hindura umuturage',
  numberOfCases: "Umubare w'ibibazo",
  totalInstitutions: 'Ibigo byose',
  institutionsWithOngoingCases: 'Ibigo bifite Ibibazo bikiri Gukorwaho',
  newInstitution: 'Ikigo gishya',
  addInstitution: 'Ongeraho ikigo',
  //TODO THIS
  ongoingCases: 'Ibigikorwaho',
  closedCases: 'Ibibazo byakemutse',
  resolvedCases: 'Ibibazo byakemutse burundu',
  reOpenedCases: 'Ibibazo byagaruwe',
  joined: 'Yinjiye',
  myCases: 'Ibibazo byanjye',
  taggedCases: 'Ibibazo byashyizweho ikimenyetso',
  organizationDetails: "Ibisobanuro by'ikigo",
  performance: 'Imikorere',
  admin: 'Umuyobozi',
  addStaff: 'Ongeraho umukozi',
  newStaff: 'Umukozi mushya',
  systemAccounts: 'Konti za sisitemu',
  role: 'Inshingano',
  lastLogin: 'Ubwa nyuma kwinjira',
  edit: 'Hindura',
  addAccount: 'Ongeraho konti',
  addRole: 'Ongeraho inshingano',
  usedBy: 'Ikoreshwa na',
  roles: 'Inshingano',
  newRole: 'Inshingano nshya',
  newAnnouncement: 'Itangazo rishya',
  unpublish: 'Kuraho itangazo',
  expiresAt: 'Rizarangira ku wa',
  announcementTitle: "Incamake ry'Itangazo",
  announcement: 'Itangazo',
  announcementValidity: 'Igihe itangazo rizamara',
  expiryDate: 'Itariki rizarangira',
  publishAnnouncement: 'Tanga itangazo',
  yourAnnouncement: 'Itangazo ryawe',
  announcementValidityDescription:
    'Iki ni gihe itangazo rizakora, niba ritashyizweho rizamara iminsi 5 kuva ritangarijwe',
  published: 'Ryatangarijwe',
  unpublished: 'Ryarangiye',
  reviewComplaint: "Tanga igitekerezo ku mwanzuro w'ikibazo",
  rating: 'Ikigero',
  commentsOptional: 'Igitekerezo (Ni amahitamo)',
  shareYourFeedback: 'Andika igitekerezo cyawe...',
  reporterReview: "Igitekerezo cy'umuturage",
  enterNationalId: 'Andika Indangamuntu',
  continue: 'Komeza',
  haveAnAccount: 'Usanzwe ufite konti?',
  selectYourPhoneNumber: 'Hitamo nimero ya telefoni',
  associatedPhoneNumbers: "Nimero zihuje n' indangamuntu yawe",
  requestVerificationCode: 'Saba kode',
  verificationCode: 'Kode yoherejwe',
  verificationCodeDescription: 'Woherejwe kode kuri nimero {{ phone }}',
  verifyCode: 'Ohereza kode',
  completeYourRegistration: 'Komeza kwiyandikisha',
  completeRegistrationDescription:
    "Injiza imeri n'Ijambo ry'Ibanga kugirango wiyandikishe",
  firstName: 'Izina rya mbere',
  lastName: 'Izina rya kabiri',
  enterEmail: 'Andika imeri',
  password: "Ijambo ry'ibanga",
  enterPassword: "Andika Ijambo ry'Ibanga",
  signUp: 'Kwiyandikisha',
  emailOrPhone: 'Imeri / Telephone',
  enterEmailOrPhoneNumber: 'Andika imeri cyangwa nimero ya telefoni',
  forgotPassword: "Wibagiwe Ijambo ry'ibanga?",
  resetPassword: 'Hinduza Ijambo banga',
  createDefaultPassword: "Shyiraho ijambo ry'ibanga ry'agateganyo",
  defaultPassword: "Ijambo ry'ibanga ry'agateganyo",
  enterDefaultPassword: "Andika ijambo ry'ibanga ry'agateganyo",
  defaultPasswordFor: "Shyiraho ijambo ry'ibanga ry'agateganyo rya",
  goToLogin: 'Kwinjira',
  code: 'Code',
  enterCode: 'Andika code',
  newPassword: "Ijambo ry'ibanga rishya",
  enterNewPassword: "Andika Ijambo ry'Ibanga rishya",
  confirmPasswordReset: "Emeza Ijambo ry'Ibanga rishya",
  noNotificationsFound: 'Nta makuru mashya',
  mentionedYouInACommentOnCase: 'yakuvuze mu gitekerezo ku kibazo',
  invitedYouToACase: 'yagutumiye ku kibazo',
  markAllAsRead: 'Shyira byose nk’ibyasomwe',
  caseNotAccessible: 'Ntabwo ufite uburenganzira bwo kureba iki kibazo',
  caseNotAccessibleHint:
    'Wamenyeshejwe kuri iki kibazo, ariko kiri hanze y’urwego ufiteho uburenganzira. Saba uwakuvuze gutumira ikigo cyawe.',
  caseNotFound: 'Ikibazo ntikibonetse',
  caseLoadFailed: 'Ikibazo ntikibashije gufungurwa',
  backToCases: 'Subira ku bibazo',
  selectInstitution: 'Hitamo ikigo',
  manageCaseCategoriesDescription:
    "Gushyiramo icyiciro cy'ibibazo n'amakuru yaho.",
  caseCategories: "Ibyiciro by'ikibazo",
  addCaseCategory: "Ongeraho icyiciro cy'ibibazo",
  updateCaseCategory: "Hindura icyiciro cy'ibibazo",
  deleteCaseCategory: "Siba icyiciro cy'ikibazo",
  caseCategoryName: "Amazina y' icyiciro cy'ikibazo",
  caseCategoryDescription: "Amakuru ya icyiciro cy'ikibazo",
  enterCaseCategoryName: "Andika amazina ya icyiciro cy'ikibazo",
  enterCaseCategoryDescription: "Andika ubusobanuro bw'icyiciro cy'ikibazo",
  editAnnouncement: 'Hindura itangazo',
  tipoffs: "Amakuru y'Ibanga",
  institutionCases: 'Ibibazo ku kigo',
  permissions: "Inshingano n'Uburenganzira",
  caseCategoriesSettings: "Ibyiciro by'ikibazo",
  createdAt: 'Byakozwe ku itariki',
  description: 'Ubusobanuro',
  refreshAnalytics: 'Jyanisha isesengura',
  analyticsRefreshed: 'Kujyanisha isesengura byagenze neza',
  errorRefreshingAnalytics: 'Kujyanisha isesengura ntibyakunze',
  organization: 'Ikigo',
  occupation: 'Umwanya',
  private: 'Ibanga',
  noTimestamp: 'Nta gihe cyashyizweho',
  theCaseWasMarkedAs: 'Ikibazo cyagizwe',
  theCaseWasEscalatedTo: 'Ikibazo cyazamuriwe urwego',
  escalatedTheCaseTo: 'Yahinduye urwego',
  rejectComplaint: 'Gufunga ikibazo',
  closeComplaint: 'Funga ikibazo',
  confirmClose: 'Emeza',
  addAComment: 'Impamvu',
  commentIsRequired: 'Impamvu yo gufunga ikibazo ni ngombwa',
  thisCommentWillBeRecordedWithTheComplaintClosure:
    "Iyi mpamvu izongerwa ku mugereka w'ikibazo",
  explainWhyThisComplaintIsBeingClosed:
    'Shyiramo impamvu yo gufunga iki kibazo',
  minimum: 'Hakenewe inyuguti',
  characters: 'Inyuguti',
  comment: 'Igitekerezo',
  createACase: 'yakoze ikibazo.',
  escalated: 'yahinduye urwego ari',
  charactersCount: 'Inyuguti',
  systemConfiguration: {
    title: 'Ni gute wifuza kwakira amatangazo',
    description: 'Hindura uburyo bwo kwakira amatangazo',
    label: 'Igenamiterere rya sisitemu',
  },
  markAs: 'EMEZA KO',
  success: 'Byakunze',
  all: 'byose',
  totalSubmittedComplaints: 'Ibibazo byose byakiriwe',
  rejectedComplaints: 'Ibyafunzwe',
  isAcknowledged: 'Icyemezo cyo Kwakira',
  acknowledgedComplaints: 'Ibibazo Byemejwe ko Byakiriwe',
  pendingComplaints: 'Ibibazo Bitegereje Kwemezwa',
  loadMore: 'Iyereke ibindi',
  totalRatings: "Ikigereranyo cy'amanota",
  orientedCases: 'Ibibazo byakozweho',
  dismissedComplaints: 'Ibibazo Byanzwe',
  avgComplaintsPerDay: "Ikigereranyo cy'ibibazo ku munsi",
  casesActivity: 'Ibyakozwe ku bibazo',
  casesActivityDescription:
    "Ibibazo byakiriwe nuko byagiye bikorwaho (Ibyakozweho n'ibitarakorwaho",
  casesPerLocation: 'Aho ibibazo biherereye',
  casesPerLocationDescription: 'Ibibazo byakiriwe mu ifasi mukoreramo',
  casesPerLocationRanking: 'Ahari ibibazo bitarakorwaho',
  casesPerLocationRankingDescription:
    'Ahari ibibazo byinshi bitarakorwaho (Ifasi 5 zibanza)',
  allLocationsOrientedComplaints: 'Ifasi zose zayoboye ibibazo byazo',
  orientedCasesPerStatus: 'Ibibazo byakiriwe',
  orientedCasesPerStatusDescription:
    'Ibibazo byakozweho naho bigeze ngo bikemurwe',
  orientedCasesPerLocation: 'Ahakiriwe ibibazo',
  orientedCasesPerLocationDescription: 'Ibibazo byakozweho mu ifasi mukoreramo',
  orientedCasesPerLocationRanking: 'Ahari ibibazo byakozweho',
  orientedCasesPerLocationRankingDescription:
    'Ahari ibibazo byinshi byakozweho (Ifasi 5 zibanza)',
  accountsUsage: 'Konti zakozwe',
  accountsUsageDescription: 'Konti zakozwe mu ifasi mukoreramo',
  activeAccountsByRole: 'Konti Zikora ku Rwego rw Inshingano',
  activeAccountsByRoleDescription:
    "Urutonde rw inshingano hashingiwe ku mubare wa konti zikora (hakuwemo konti z'abandi bakozi)",
  noActiveAccountsByRole: 'Nta konti ikora yabonetse',
  accountsPerLocation: 'Aho konti ziherereye',
  accountsPerLocationDescription: 'Konti zakozwe mu ifasi mukoreramo',
  complaintStatistics: "Ikigereranyo cy'ibibazo ku munsi",
  complaintStatisticsDescription: "Imibare y'ibibazo n'uko byinjijwe",
  active: 'Izikora',
  inactive: 'Izidakora',
  resolved: 'Ibyakemutse burundu',
  nonOriented: 'Ibitarakorwaho',
  oriented: 'Ibyakozweho',
  dismissed: 'Ibyanzwe',
  province: 'Intara',
  filterByLocation: 'Hitamo ku Ifasi',
  escalationNote: 'Impamvu yo guhindura urwego',
  platformStatistics: "Ikigereranyo cy'uko sisitemu ikoreshwa",
  officerComment: "Impamvu y'umukozi",
  chatAssistant: {
    title: 'Umufasha wa Mbaza',
    subtitle: 'Baza ibibazo ku makuru yawe',
    emptyGreeting:
      "Mbaza ikintu cyose ku birego by'abaturage, ibikorwa by'abakozi, cyangwa uko uturere tumeze.",
    placeholder: 'Baza ku birego, imiterere...',
    send: 'Ohereza',
    error: 'Mbabarira, sinashoboye kubona igisubizo. Ongera ugerageze.',
    toastError: 'Kubona igisubizo kuri umufasha byanze',
    openAriaLabel: "Fungura umufasha w'ikiganiro",
    closeAriaLabel: "Funga umufasha w'ikiganiro",
    suggestions: {
      locationPerformance: "Ahantu hanjye hameze hate ku birebana n'ibirego?",
      staffLogins: 'Ni abakozi bangahe binjiye muri sisitemu mu kwezi gushize?',
      unresolvedByDistrict:
        'Ni akahe karere gafite ibirego byinshi bitarakemuka?',
      avgResolutionTime: 'Ni igihe kingana iki cyo gukemura ikirego?',
      emergingTrends: "Hari imiterere mishya y'ibirego muri iki cyumweru?",
    },
  },
};

export default rw;
